export default __webpack_public_path__ + "static/media/Roboto-BlackItalic.6a93c6dc.ttf";